<template>
<div>
    <v-dialog v-model="basket" width="1200" max-width="1200" :fullscreen="$vuetify.breakpoint.xs ? true : false">
        <v-card class="mx-auto" tile flat max-width="1200">
            <v-app-bar tile color="white" flat>
                <v-toolbar-title class="grey--text">
                    <v-icon>shopping_cart</v-icon> Кошик
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$store.commit('setShoppingCartDialog', false)">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-app-bar>
            <!-- <v-container style="max-height: 600px;" class="overflow-y-auto px-0"> -->
            <!-- <v-progress-linear indeterminate v-if="overlay" color="primary"></v-progress-linear> -->
            <v-container class="overflow-y-auto px-0">
                <v-tabs background-color="white" color="primary" class="px-4 card" v-model="tab">
                    <v-tab :class="$vuetify.breakpoint.xs ? `px-2` : ``">Замовлення ({{ current.length }})</v-tab>
                    <template v-if="contactInfo.groups && contactInfo.groups.cl_corp_presale ? true : false">
                        <v-tab :class="$vuetify.breakpoint.xs ? `px-2` : ``">Передзамовлення
                            ({{ preorder.length }})</v-tab>
                    </template>

                    <v-tab-item>
                        <div v-if="!errorLoadingData && !cartTimeout &&  current.length == 0" class="pa-10 subtitle-1 grey--text text-center">
                            <span v-if="!overlay">
                                <v-icon>mdi-cart-outline</v-icon> Кошик порожнiй
                            </span>
                            <span v-if="overlay">Зачекайте..</span>
                        </div>
                        <div v-if="errorLoadingData" class="pa-10 body-2 error--text text-center">
                            <v-icon color="error" class="mr-2 mb-2">mdi-alert</v-icon>Вибачте, виникла помилка!
                            Повторіть спробу через
                            декілька хвилин.
                        </div>
                        <div v-if="cartTimeout && !errorLoadingData"  class="pa-10 grey--text text-center">
                            <v-icon color="grey" class="mr-2 mb-2" >mdi-sleep</v-icon><br>Ви залишили кошик відкритим на довгий час.<br>За цей час його наповнення могло змінитися.<br>
                            <v-btn @click="reloadBasket()" color="info" text class="mt-4"><v-icon dark class="mr-2 mb-2">mdi-reload</v-icon>Оновити кошик</v-btn>
                        </div>

                        <ShoppingCartTable v-if="!errorLoadingData && !cartTimeout" type="available" />
                        <ShoppinCartGifts />
                        <template v-if="reserve[0] && !errorLoadingData && !cartTimeout">
                            <div class="mt-4 subtitle-2 grey--text ">У РЕЗЕРВІ (пошукайте)</div>
                            <ShoppingCartTable type="reserve" />
                        </template>
                        <template v-if="absent[0]">
                            <h4 class="mt-4 subtitle-2 grey--text ">НЕМАЄ (товари цього списку у замовлення не
                                додаються)</h4>
                            <ShoppingCartTable type="absent" v-if="!errorLoadingData && !cartTimeout"/>
                        </template>
                    </v-tab-item>
                    <template v-if="contactInfo.groups && contactInfo.groups.cl_corp_presale ? true : false">
                        <v-tab-item>
                            <div v-if="preorder.length == 0" class="pa-10 subtitle-1 grey--text text-center">
                                <v-icon>mdi-cart-outline</v-icon> Кошик порожнiй
                            </div>
                            <ShoppingCartTable type="preorder" v-if="!errorLoadingData && !cartTimeout"/>
                        </v-tab-item>
                    </template>
                </v-tabs>

                    <!-- <v-alert type="error" class="mt-4 mx-4">Шановні клієнти,<br>
                    у зв’язку з переїздом нашого складу на нову локацію тимчасово призупинено прийом нових замовлень.
                    </v-alert> -->

                <v-container fluid>
                    <v-row>
                        <v-col cols="12" sm="6" xs="12" class="d-flex align-sm-end justify-center justify-sm-start">
                            <v-card flat>
                                <v-card-text class="d-none">

                                </v-card-text>
                                <v-card-actions class="d-flex flex-column align-stretch">
                                    <v-btn :disabled="preorder.length == 0 && current.length == 0" @click="create()" :loading="xlsLoading" class="mb-4">
                                        <span class="mr-2">
                                            <v-icon color="green darken-3">{{ exclelIcon }}</v-icon>
                                        </span>
                                        Завантажити
                                    </v-btn>
                                    <v-btn @click="$store.commit('setShoppingCartDialog', false)" class="ml-0">
                                        Повернутися до каталогу
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" xs="12">
                            <v-card color="grey lighten-4" flat v-if="tab == 0">
                                <v-card-text class="text-center text-sm-left">
                                    <div v-if="discount">
                                        Ваша знижка:
                                        <span class="caption">{{ discount.toLocaleString('ru-RU') }} <span class="">₴</span></span>
                                    </div>
                                    <div>
                                        Разом:
                                        <v-btn class="mt-n1" title="Ціна контролюється вендором" v-if="totalSumRoc && is_roc" color="primary" small icon @click.stop="open_roc_control_dialog(totalSumRoc)">
                                            <v-icon>mdi-alert-circle</v-icon>
                                        </v-btn>
                                        <span class="title font-weight-bold">{{ totalSum.toLocaleString('ru-RU') }}
                                            <span class="body-2">₴</span></span>
                                    </div>
                                </v-card-text>
                                <v-card-text v-if="actionsConditions.length">
                                    <v-alert type="error" outlined dense class="caption mb-0">
                                        <div><span class="font-weight-bold">Увага!</span> У кошику є акційні товари,
                                            по
                                            яких не виконується умова акції. Купити ці товари без акції?</div>
                                        <v-btn small class="my-2" color="primary" @click="clearActions()">
                                            Очистити акції
                                        </v-btn>
                                    </v-alert>
                                </v-card-text>
                                <v-card-text v-if="contactInfo && contactInfo.userId && !contactInfo.contractorId">
                                    <v-alert type="error" outlined dense class="caption mb-0">
                                        Немає жодного доступного контрагента для створення замовлення.<br>
                                        Зверніться до закріпленого за вами менеджера.
                                    </v-alert>
                                </v-card-text>

                                <v-card-text>
                                    <v-alert v-if="accumulativeActionsList.length && totalSum > 0" icon="mdi-gift" outlined type="success">
                                        <!-- {{accumulativeActionId}}-{{totalSumWa}} -->
                                        <div class="font-weight-bold">Оформити замовлення як подарунок на доступні
                                            бали
                                            по акції (1 бал = 1 гривня):</div>
                                        <div class="caption second--text">* вартість товарів враховується за ціною
                                            без
                                            акцій</div>
                                        <div class="caption second--text">** враховуються лише товари, які є на
                                            вільних
                                            залишках</div>
                                        <div v-for="(item, key) in accumulativeActionsList" :key="key" class="d-flex justify-space-between">
                                            <v-checkbox v-model="accumulativeActionId" :value="item.id" @click="openAccumulativeActionsDialog" hide-details :disabled="Math.ceil(totalSumWa) <= parseInt(item.points) ? false : true">
                                                <template v-slot:label>
                                                    <span class="subtitle-2 second--text">{{ item.name }}</span>
                                                </template>
                                            </v-checkbox>
                                            <span class="body-2 pt-1 mt-5 second--text">Доступно: {{ item.points }}
                                                балів</span>
                                        </div>
                                    </v-alert>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn class="mx-auto mx-sm-0" v-if="(available.length || reserve.length) && totalSum > 0" color="primary" @click="checkout()" :disabled="!contactInfo.contractorId || actionsConditions.length ? true : false">
                                        Оформити замовлення
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                            <v-card color="grey lighten-4" flat v-if="tab == 1">
                                <v-card-text class="text-center text-sm-left">
                                    <div>Разом: <span class="title font-weight-bold">{{
                                                totalSumPreorder.toLocaleString('ru-RU') }}
                                            <span class="body-2">₴</span></span></div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn class="mx-auto mx-sm-0" v-if="preorder.length && totalSumPreorder > 0" color="primary" @click="checkoutPreorder()">
                                        Оформити передзамовлення
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
                <v-overlay :value="overlay" absolute opacity='0.25'>
                    &nbsp;
                </v-overlay>
            </v-container>
        </v-card>
        <v-overlay :value="overlay" absolute opacity='0'>
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-dialog>
    <!-- Контроль РОЦ -->
    <v-dialog v-model="roc_control_dialog" max-width="290" overlay-opacity="1" overlay-color="grey">
        <v-card>
            <v-card-title class="headline">Ваша цiна:</v-card-title>

            <v-card-text class="headline second--text text-center my-4">
                <span class="body-1">Разом:</span> {{ roc_control_price.toLocaleString('ru-RU') }} <span class="body-2">₴</span>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="roc_control_dialog = false">
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog persistent v-model="accumulativeActionsDialog" width="600" max-width="100%" class="error">
        <v-card width="100%">
            <v-card-title class="error white--text">Увага!</v-card-title>
            <v-card-text class="mt-6">
                <p>Для <b>замовлення як подарунок на доступні бали</b> кошик буде приведено у відповідність до вимог
                    такого замовлення:<br>
                    <ul>
                        <li>всі акції по товарам будуть очищені,</li>
                        <li>залишені лише товари, які є на вільних залишках.</li>
                    </ul>
                </p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="confirmAccumulativeActionsDialog()">
                    Застосувати
                </v-btn>
                <v-btn color="primary" text @click="closeAccumulativeActionsDialog()">
                    Скасувати
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import {
    mapActions
} from 'vuex'
import {
    mdiMicrosoftExcel
} from '@mdi/js'
import {
    connect
} from "../ReportSocket"

import ShoppingCartTable from '@/components/ShoppingCartTable.vue'
import ShoppinCartGifts from '@/components/ShoppinCartGifts.vue'
export default {
    components: {
        ShoppingCartTable,
        ShoppinCartGifts
    },
    data: () => ({
        xlsLoading: false,
        exclelIcon: mdiMicrosoftExcel,
        mime: {
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
            xml: "application/xml"
        },
        format: '',
        se: {},
        socket: {},
        closed: true,
        shoppingCartData: [],
        tab: null,
        overlay: true,
        roc_control_dialog: false,
        roc_control_price: NaN,
        is_roc: false,
        nophoto: 'data:image/png;base64,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',
        giftsData: {},
        actionsGifts: {},
        accumulativeActionsDialog: false,
        accumulativeActionConfirmed: false,
        errorLoadingData: false,
        timeoutId: null,
        cartTimeout: false,
        clearTimeout: 5 * 60 * 1000 // 5 min
    }),
    methods: {
        ...mapActions(['touch', 'getShoppingCart', 'setSnackbar', 'getShoppingCartData', 'setShoppingCartData', 'getGoodsPrizes', 'getProductActionsData', 'getProductActionsDataSilent', 'getAccumulativeActions']),

        async connectSocket() {
            try {
                const {
                    se,
                    socket
                } = await connect()

                this.loaded = false
                this.xlsLoading = false
                this.se = se
                this.socket = socket
                console.log('Websocket connected')
                this.se.$on("message", (msg) => {
                    const date = new Date().toISOString()
                    const filename = `shopping_cart.xlsx`
                    this.fileName = filename
                    this.saveData(msg, filename);
                    this.loaded = false
                    this.xlsLoading = false
                })
                this.se.$on("closed", () => {
                    setTimeout(() => {
                        this.closed = true
                        console.log("Websocket closed")
                    }, 5000);
                })
                this.se.$on("error", (error) => {
                    console.error("Не вдалося встановити з'єднання з сервером")
                    //this.setSnackbar(['error', "Не вдалося встановити з'єднання з сервером"])
                })
                this.se.$on("opened", () => {
                    this.closed = false
                    this.xlsLoading = false
                })
            } catch (error) {
                console.error(error)
            }
        },
        async create() {
            if (this.closed) {
                try {
                    this.xlsLoading = true
                    await this.connectSocket()
                    this.closed = false
                } catch (error) {
                    console.error(error)
                    this.xlsLoading = false
                }
            }
            if (this.socket.readyState == 1) {
                this.loaded = true
                this.xlsLoading = true
                const shoppingCart = this.all
                try {
                    const scObj = await this.getShoppingCartData() || {}
                    this.shoppingCartGiftsData = scObj.gifts_data
                } catch (error) {
                    console.error(error)
                }
                this.touch()
                    .then(() => {
                        this.setShoppingCartData({
                                shoppingCart,
                                giftsData: this.shoppingCartGiftsData
                            })
                            .then(() => {
                                window.URL.revokeObjectURL(this.fileBlobURL); //очистить память от ранее принятого файла
                                this.fileBlobURL = ''
                                const token = this.getLocalStorage('authToken')
                                this.se.send(JSON.stringify({
                                    fileName: Math.random() + '_shopping_cart.xlsx',
                                    authToken: token,
                                    type: 'shopping-cart',
                                }))
                            })
                    })
            } else {
                this.setSnackbar(['error', "Не вдалося встановити з'єднання з сервером WS!"])
            }
        },
        saveData(data, fileName, format) {
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            const blob = new Blob([data], {
                type: this.mime[this.format]
            })
            let url = window.URL.createObjectURL(blob);
            this.fileBlobURL = a.href = url;
            a.download = fileName;
            a.click();
        },
        getLocalStorage(f) {
            let value = ''
            try {
                value = localStorage[f] ? JSON.parse(localStorage[f]) : ''
            } catch (error) {
                console.error(error)
                return ''
            }
            return value
        },
        setLocalStorage(f, v) {
            localStorage[f] = JSON.stringify(v)
        },
        open_roc_control_dialog(v) {
            this.roc_control_dialog = true
            this.roc_control_price = v
        },
        async getShoppingCartItems() {
            this.overlay = true
            let dataFromBackEnd = []
            try {
                const scObj = await this.getShoppingCartData() || {}
                this.shoppingCartData = scObj.data
                this.shoppingCartGiftsData = scObj.gifts_data
                dataFromBackEnd = await this.getShoppingCart()

            } catch (error) {
                console.error(error)
            }
            this.overlay = false
            const availableData = []
            const preorderData = []
            const reserveData = []
            const absentData = []
            let c = 0

            for (let item of this.shoppingCartData) {
                if (item.is_gift_action && !this.shoppingCartGiftsData[item.prodset_id] && item.group_id != -1) {
                    this.getProductActionsDataSilent(item.typhoon_id)
                        .then(async actionsData => {
                            Object.assign(this.actionsGifts, actionsData.actionsGifts)
                            this.recalcDefaultGifts(item.prodset_id)
                            this.$set(this.shoppingCartGiftsData, item.prodset_id, this.giftsData[item.prodset_id])
                        })
                }
                const el = dataFromBackEnd.find(e => e.typhoon_full_id == item.typhoon_full_id)
                if (el) {
                    el.cnt = item.cnt
                    el.price_uah_old = item.price_uah

                    if (el.status == 'available') {
                        availableData.push(el)
                    } else if (el.status == 'reserve') {
                        reserveData.push(el)
                    } else if (el.status == 'in_transit' || el.status == 'on_demand') {
                        preorderData.push(el)
                    } else {
                        absentData.push(item)
                    }
                } else {
                    if (item.typhoon_full_id) {
                        absentData.push(item)
                    }
                }
            }
            this.$store.commit('setShoppingCartAvailable', availableData)
            this.$store.commit('setShoppingCartPreorder', preorderData)
            this.$store.commit('setShoppingCartReserve', reserveData)
            this.$store.commit('setShoppingCartAbsent', absentData)
        },
        clearShoppingCartData() {
            this.$store.commit('setShoppingCartAvailable', [])
            this.$store.commit('setShoppingCartPreorder', [])
            this.$store.commit('setShoppingCartReserve', [])
            this.$store.commit('setShoppingCartAbsent', [])
        },
        recalcDefaultGifts(prodset_id) {
            if (this.actionsGifts[prodset_id]) {
                for (let group_id in this.actionsGifts[prodset_id]) {
                    if (!this.giftsData[prodset_id]) {
                        this.$set(this.giftsData, prodset_id, {})
                    }
                    this.$set(this.giftsData[prodset_id], group_id, this.actionsGifts[prodset_id][group_id][0])
                }
            } else {
                this.giftsData = {}
            }
        },
        checkout() {
            this.$store.commit('setShoppingCartDialog', false)
            this.$router.push('/checkout')
        },
        checkoutPreorder() {
            this.$store.commit('setShoppingCartDialog', false)
            this.$router.push('/checkout-preorder')
        },
        deleteGifts(item) {
            if (this.goodsPrizes[item.typhoon_id]) {
                for (let prodset_id of this.goodsPrizes[item.typhoon_id]) {
                    this.$delete(this.shoppingCartGiftsData, prodset_id)
                }
            }
        },
        clearActions() {
            const availableData = this.available
            for (let groupId of this.actionsConditions) {
                for (let item of this.available) {
                    if (item.group_id == groupId) {
                        this.deleteGifts(item)
                        item.group_id = -1
                        this.actionGroup = -1
                    }
                }
            }
            this.$store.commit('setShoppingCartAvailable', availableData)
            const shoppingCart = this.all
            this.touch()
                .then(() => {
                    this.setShoppingCartData({
                            shoppingCart,
                            giftsData: this.shoppingCartGiftsData
                        })
                        .then(() => {
                            this.getShoppingCartItems()
                        })
                        .catch(error => console.error(error))
                })
        },
        clearAllActions() {
            for (let item of this.available) {
                this.$set(item, 'group_id', -1)
                this.$set(item, 'prodset_id', -1)
                this.$set(item, 'act_id', null)
                this.$set(item, 'act_qty', null)
                this.$set(item, 'act_name', null)
            }
            this.shoppingCartGiftsData = {}
            this.$store.commit('setShoppingCartAvailable', this.available)
            this.$store.commit('setShoppingCartReserve', [])
            this.$store.commit('setShoppingCartAbsent', [])

            const shoppingCart = this.all
            this.touch()
                .then(() => {
                    this.setShoppingCartData({
                            shoppingCart,
                            giftsData: this.shoppingCartGiftsData
                        })
                        .then(() => {
                            this.getShoppingCartItems()
                        })
                        .catch(error => console.error(error))
                })
        },
        checkMultiCond(item, totalCnt) {
            if (item.typhoon_check_lot) {
                return totalCnt >= item.act_qty ? false : true
            } else {
                return totalCnt % item.act_qty ? true : false
            }
        },
        recalcGiftsQty(item) {
            if (this.shoppingCartGiftsData[item.prodset_id]) {
                for (let group_id in this.shoppingCartGiftsData[item.prodset_id]) {
                    const el = this.shoppingCartGiftsData[item.prodset_id][group_id]
                    let qty = el.qty
                    const cnt = this.groupsTotalQty[item.prodset_id]
                    if (!item.typhoon_check_lot) {
                        qty = ((cnt - cnt % item.act_qty) / item.act_qty) * el.qty
                    }
                    this.$set(el, 'qty_total', qty)
                }
            }
        },
        openAccumulativeActionsDialog() {
            this.accumulativeActionConfirmed = false
            if (this.accumulativeActionId) {
                this.accumulativeActionsDialog = true
            }
        },
        confirmAccumulativeActionsDialog() {
            this.accumulativeActionsDialog = false
            this.clearAllActions()
            this.accumulativeActionConfirmed = true
            this.accumulativeActionData = this.accumulativeActionsList.find(el => el.id == this.accumulativeActionId) || {}
        },
        closeAccumulativeActionsDialog() {
            this.accumulativeActionsDialog = false
            this.accumulativeActionId = null
            this.accumulativeActionConfirmed = false
        },
        reloadBasket() {
            this.errorLoadingData = false
                this.touch()
                    .then(() => {
                        this.cartTimeout = false
                        this.timeoutId = setTimeout(() => {
                            this.cartTimeout = true
                            this.clearShoppingCartData()
                        }, this.clearTimeout  )

                        this.accumulativeActionId = null
                        this.getAccumulativeActions()
                        this.getShoppingCartItems()
                            .then(() => {
                                if (!this.current.length && this.preorder.length) {
                                    this.tab = 1
                                } else {
                                    this.tab = 0
                                }
                                for (let item of this.available) {
                                    this.recalcGiftsQty(item)
                                }
                            })
                            .catch(error => {
                                this.setSnackbar(['error', error])
                                this.errorLoadingData = true
                                this.clearShoppingCartData()
                                this.overlay = false
                            })
                    })
                    .catch(error => {
                        this.setSnackbar(['error', error])
                        this.errorLoadingData = true
                        this.clearShoppingCartData()
                        this.overlay = false
                    })
        }

    },
    mounted() {
        this.getGoodsPrizes()
        this.getAccumulativeActions()
        this.cartTimeout = false
        this.errorLoadingData = false
    },
    computed: {
        basket: {
            get: function () {
                return this.$store.state.main.shoppingCartDialog
            },
            // setter
            set: function (v) {
                this.$store.commit('setShoppingCartDialog', v)
            }
        },
        actionGroup: {
            get: function () {
                return this.$store.state.catalog.actionGroup
            },
            set: function (v) {
                this.$store.commit('setActionGroup', v)
            }
        },
        actionProdset: {
            get: function () {
                return this.$store.state.catalog.actionProdset
            },
            set: function (v) {
                this.$store.commit('setActionProdset', v)
            }
        },
        accumulativeActionId: {
            get: function () {
                return this.$store.state.catalog.accumulativeActionId
            },
            set: function (v) {
                this.$store.commit('setAccumulativeActionId', v)
            }
        },
        accumulativeActionData: {
            get: function () {
                return this.$store.state.catalog.accumulativeActionData
            },
            set: function (v) {
                this.$store.commit('setAccumulativeActionData', v)
            }
        },
        shoppingCartGiftsData: {
            get: function () {
                return this.$store.state.catalog.shoppingCartGiftsData
            },
            set: function (v) {
                this.$store.commit('setShoppingCartGiftsData', v)
            }
        },
        goodsPrizes() {
            return this.$store.state.catalog.goodsPrizes
        },
        available() {
            return this.$store.state.main.shoppingCartAvailable
        },
        preorder() {
            return this.$store.state.main.shoppingCartPreorder
        },
        reserve() {
            return this.$store.state.main.shoppingCartReserve
        },
        absent() {
            return this.$store.state.main.shoppingCartAbsent
        },
        totalSum() {
            let sum = 0
            if (this.available) {
                this.available.forEach(el => {
                    sum += (el.is_priceoff ? el.priceoff_price_uah : el.price_uah) * el.cnt
                })
            }
            if (this.reserve) {
                this.reserve.forEach(el => {
                    sum += el.price_uah * el.cnt
                })
            }
            return sum
        },
        totalSumWa() {
            let sum = 0
            if (this.available) {
                this.available.forEach(el => {
                    sum += el.price_uah_without_action * el.cnt
                })
            }
            if (this.reserve) {
                this.reserve.forEach(el => {
                    sum += el.price_uah_without_action * el.cnt
                })
            }
            return sum
        },
        discount() {
            return this.totalSumWa - this.totalSum
        },
        totalSumRoc() {
            let sum = 0
            if (this.available) {
                this.available.forEach(el => {
                    sum += el.price_without_roc_uah * el.cnt
                    if (el.is_price_roc) {
                        this.is_roc = true
                    }
                })
            }
            if (this.reserve) {
                this.reserve.forEach(el => {
                    sum += el.price_without_roc_uah * el.cnt
                    if (el.is_price_roc) {
                        this.is_roc = true
                    }
                })
            }
            return sum.toLocaleString('ru-RU')
        },
        totalSumPreorder() {
            let sum = 0
            if (this.preorder) {
                this.preorder.forEach(el => {
                    sum += el.price_uah * el.cnt
                })
            }
            return sum
        },
        all() {
            return [...this.available, ...this.preorder, ...this.reserve, ...this.absent]
        },
        current() {
            return [...this.available, ...this.reserve, ...this.absent]
        },
        data() {
            let input = this.$store.state.main.shoppingCartAvailable
            const data = {}
            for (let el of input) {
                if (!data[el.group_id]) {
                    data[el.group_id] = []
                }
                data[el.group_id].push(el)
            }
            for (let groupId in data) {
                let totalCnt = 0
                for (let item of data[groupId]) {
                    totalCnt = totalCnt + item.cnt
                }
                data[groupId][0].totalCnt = totalCnt
            }
            return data
        },
        actionsConditions() {
            const out = []
            for (let groupId in this.data) {
                let totalCnt = this.data[groupId] && this.data[groupId][0] && this.data[groupId][0].totalCnt
                for (let item of this.data[groupId]) {
                    if (this.checkMultiCond(item, totalCnt)) {
                        if (groupId != -1)
                            out.push(groupId)
                    }
                }
            }
            return out
        },
        contactInfo() {
            return this.$store.state.main.contactInfo
        },
        groupsTotalQty() {
            const groupsQty = {}
            for (let groupId in this.data) {
                for (let item of this.data[groupId]) {
                    if (!groupsQty[item.prodset_id]) {
                        groupsQty[item.prodset_id] = 0
                    }
                    groupsQty[item.prodset_id] = groupsQty[item.prodset_id] + item.cnt
                }
            }
            return groupsQty
        },
        accumulativeActionsList() {
            return this.$store.state.catalog.accumulativeActionsList
        },
    },
    watch: {
        basket(v) {
            this.tab = this.$store.state.main.shoppingCartDialogTab
            clearTimeout(this.timeoutId)
            if (v) {
                this.reloadBasket()
            } else {
                if (!this.errorLoadingData && !this.overlay && !this.cartTimeout) {
                    this.touch()
                        .then(() => {
                            this.cartTimeout = false
                            const shoppingCart = this.all
                            let giftsData = this.shoppingCartGiftsData
                            if (this.available.length == 0 && this.reserve.length == 0) {
                                giftsData = {}
                            }
                            this.setShoppingCartData({
                                    shoppingCart,
                                    giftsData
                                }).then(async () => {
                                    this.$store.commit('setShoppingCartCounter', this.all.length)
                                })
                                .catch(error => {
                                    this.setSnackbar(['error', 'Помилка збереження кошика'])
                                })
                        })
                }
            }
        }
    },
}
</script>

<style>

.v-dialog.v-dialog--active {
    position: relative;
}
@media(max-width: 599px) {

    .card .v-slide-group__prev,
    .card .v-slide-group__next {
        display: none !important;
    }
}
</style>
